"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeOptions = exports.fixSchemaOptions = exports.defaultOptions = void 0;
var schemaMethods_1 = require("../schemaMethods");
var validationMessages_1 = require("../validationMessages");
/**
 * domyslne opcje schematu
 */
exports.defaultOptions = {
    Vue: null,
    resetOnFocus: true,
    dirtyOnInput: false,
    dirtyOnBlur: true,
    disableCalculations: false,
    disableValidations: false,
    startDirty: false,
    schemaMethods: schemaMethods_1.default,
    wrapAll: false,
    fixData: true,
    validationMessages: validationMessages_1.default,
    warningMessages: validationMessages_1.default,
    form: {},
    external: {},
    disabledFields: {}
};
/**
 * łączenie opcji z opcjami domyslnymi
 *
 * @export
 * @param {*} [options]
 * @returns {IOptions}
 */
function fixSchemaOptions(options) {
    var result = {};
    mergeOptions(result, exports.defaultOptions);
    if (options) {
        mergeOptions(result, options);
    }
    return result;
}
exports.fixSchemaOptions = fixSchemaOptions;
/**
 * dołaczanie opcji *
 * @export
 * @param {IOptions} options
 * @param {IOptions} optionsToMerge
 */
function mergeOptions(options, optionsToMerge) {
    for (var key in optionsToMerge) {
        if (optionsToMerge.hasOwnProperty(key)) {
            var value = optionsToMerge[key];
            if ((typeof value === 'object') && (value != null)) {
                if (options[key] === undefined) {
                    options[key] = {};
                }
                mergeOptions(options[key], value);
            }
            else {
                options[key] = value;
            }
        }
    }
}
exports.mergeOptions = mergeOptions;
//# sourceMappingURL=IOptions.js.map